module.exports = __webpack_public_path__ + "static/media/Schwester_Sara.85065b29.jpg";